import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'un-button',
  templateUrl: 'button.component.html',
  styleUrls: ['button.component.scss'],
})
export class ButtonComponent {
  @Input() public type: 'light' | 'default' | 'dashed' = 'default';
  @Input() public isDisabled: boolean = false;
  @Input() public isSubmit: boolean = false;
  @HostBinding('class.full-width')
  @Input()
  public fullWidth: boolean = false;
}
